import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { CONFIG } from '../../environments/config';
import { config } from 'rxjs';
import { Category, gridPageRequest, ProductGroup } from '../model/common/common.model';

@Injectable({
  providedIn: 'root'
})
export class AdministratorService {

  constructor(private httpClientService: HttpClientService) { }

  public getAllRoles() {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GETALLROLES}`);
  }

  public getRoleById(id: any) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GETROLEBYID}?id=${id}`);
  }

  public createRole(data: any) {
    return this.httpClientService.post(CONFIG.ADMINISTRATION.CREATEROLE, data);
  }

  public deleteRole(roleId: any, isActive: boolean) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.DELETEROLE}/${roleId}?isActive=${isActive}`);
  }

  public updateRole(data: any) {
    return this.httpClientService.post(CONFIG.ADMINISTRATION.UPDATEROLE, data);
  }

  public getAllUnitsOfMeasure(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.GETALLUNITOFMEASURE}`, data);
  }

  public getUnitsOfMeasureId(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GETUNITOFMEASURE}?${queryParam}`);
  }

  public createUnitsOfMeasure(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.CREATEUNITOFMEASURE}`, data);
  }

  public updateUnitsOfMeasure(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.UPDATEUNITOFMEASURE}`, data);
  }

  public deleteUnitsOfMeasure(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.DELETEUNITOFMEASURE}`, data);
  }

  public autoSearchUMO(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.AUTOSEARCHUMO}?searchText=${seachkey}`);
  }

  public getAllPaymentTerms(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.GETALLPAYMENTTERMS}`, data);
  }

  public getPaymentTermsId(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GETPAYMENTTERMS}?${queryParam}`);
  }

  public createPaymentTerms(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.CREATEPAYMENTTERMS}`, data);
  }

  public updatePaymentTerms(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.UPDATEPAYMENTTERMS}`, data);
  }

  public deletePaymentTerms(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.DELETEPAYMENTTERMS}`, data);
  }

  public autoSearchPayment(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.AUTOSEARCHPAYMENT}?searchText=${seachkey}`);
  }
  public getAllWarehouse(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.GETALLWAREHOUSE}`, data);
  }
  public getAllCompanyWarehouse(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.GETALLCOMPANYWAREHOUSE}`, data);
  }
  public getWarehouseById(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GETWAREHOUSE}?${queryParam}`);
  }
  public createWarehouse(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.CREATEWAREHOUSE}`, data);
  }

  public updateWarehouse(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.UPDATEWAREHOUSE}`, data);
  }

  public deleteWarehouse(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.DELETEWAREHOUSE}`, data);
  }

  public searchWarehouse(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.AUTOSEARCHWAREHOUSE}?searchText=${seachkey}`);
  }
  public getWarehousesByCompanyId(companyID: any) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GETWAREHOUSEBYCOMPANYID}?companyID=${companyID}`);
  }

  public searchWarehouseByCompany(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.AUTOSEARCHCOMPANYWAREHOUSE}?searchText=${seachkey}`);
  }

  public getWmsLocations(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.GETWMSLOCATIONS}`, data);
  }

  public getWmsLocationById(id: any) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GETWMSLOCATIONBYID}?id=${id}`);
  }

  public createWmsLocation(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.CREATEWMSLOCATION}`, data);
  }

  public updateWmsLocation(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.UPDATEWMSLOCATION}`, data);
  }

  public deleteWmsLocations(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.DELETEWMSLOCATIONS}`, data);
  }

  public searchWmsLocations(searchKey: string) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.SEARCHWMSLOCATIONS}?searchText=${searchKey}`);
  }

  public getProductLocations(productId: number, warehouseId?: number) {
    let url = `${CONFIG.ADMINISTRATION.GETPRODUCTLOCATIONS}?productId=${productId}`;
    if (warehouseId) {
      url += `&warehouseId=${warehouseId}`;
    }
    return this.httpClientService.get(url);
  }

  public saveProductLocations(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.SAVEPRODUCTLOCATIONS}`, data);
  }

  public deleteProductLocations(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.DELETEPRODUCTLOCATIONS}`, data);
  }

  public getMenu() {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GETMENU}`);
  }

  public getRoleMenu(data: any) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GETROLEMENU}?id=${data}`);
  }

  public getRoleMenus(data: any) {
    return this.httpClientService.post(CONFIG.ADMINISTRATION.GETROLEMENUS, data);
  }

  public GetAllMenu() {
    return this.httpClientService.get(CONFIG.ADMINISTRATION.GETALLMENU);
  }

  public AddMenu(data: any) {
    return this.httpClientService.post(CONFIG.ADMINISTRATION.ADDMENU, data);
  }

  public AddSubMenu(menuid: any, data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.ADDSUBMENU}/${menuid}/addsubmenu`, data);
  }

  public autoSearchMenu(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.AUTOSEARCHMENU}?searchText=${seachkey}`);
  }

  public getAllGST(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.GET_GSTLIST}`, data);
  }

  public deleteGST(GSTId: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.DELETE_GST}/${GSTId}`);
  }


  public createGST(data: any) {
    return this.httpClientService.post(CONFIG.ADMINISTRATION.CREATE_GST, data);
  }

  public updateGST(data: any) {
    return this.httpClientService.post(CONFIG.ADMINISTRATION.UPDATE_GST, data);
  }

  public autoSearchGST(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.AUTOSEARCHCGST}?searchText=${seachkey}`);
  }

  public getAllProjectBom(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.GETALLPROJECTBOM, data)
  }

  public getCatagoryList(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_CATEGORYLIST, data);
  }

  public getCatagoryById(id: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_CATEGORYBYID}?id=${id}`);
  }

  public createCatagory(data: Category) {
    return this.httpClientService.post(CONFIG.INVENTORY.CREATE_CATEGORY, data);
  }

  public updateCatagory(data: Category) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_CATEGORY, data);
  }

  public deleteCatagory(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_CATEGORY, data);
  }

  public searchProductCategory(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.SEARCHPRODUCTCATEGORY}?searchText=${seachkey}`);
  }
  public getAllProductGroup() {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_ALL_PRODUCTGROUP}`);
  }

  //Product group
  public getProductGroupList(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_PRODUCTGROUPLIST, data);
  }
  public getProductGroupById(id: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PRODUCTGROUPID}?id=${id}`);
  }
  public createProductGroup(data: ProductGroup) {
    return this.httpClientService.post(CONFIG.INVENTORY.CREATE_PRODUCTGROUP, data);
  }
  public updateProductGroup(data: ProductGroup) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_PRODUCTGROUP, data);
  }
  public deleteProductGroup(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_PRODUCTGROUP, data);
  }
  public searchProductGroup(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.SEARCHPRODUCTGROUP}?searchText=${seachkey}`);
  }


  // Product Sub Category
  public getAllCategory() {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_ALL_CATEGORY}`);
  }
  public getProductSubCategoryList(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_SUBCATEGORYLIST, data);
  }
  public getProductSubCategoryById(id: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_SUBCATEGORYBYID}?id=${id}`);
  }
  public createProductSubCategory(data: ProductGroup) {
    return this.httpClientService.post(CONFIG.INVENTORY.CREATE_SUBCATEGORY, data);
  }
  public updateProductSubCategory(data: ProductGroup) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_SUBCATEGORY, data);
  }
  public deleteProductSubCategory(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_SUBCATEGORY, data);
  }
  public searchProductSubCategory(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.SEARCHPRODUCTSUBCATEGORY}?searchText=${seachkey}`);
  }

  public autogenerateSubCategoryCode() {
    return this.httpClientService.get(CONFIG.INVENTORY.AUTOGENERATE_SUBCATEGORYCODE);
  }
  public checkSubCategoryCode(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.CHECK_SUBCATEGORY_CODE}?SubCategoryCode=${data}`);
  }

  // Company Information

  public getCompanyInformationId(id: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GETCOMPANYINFOBYID}?id=${id}`);
  }

  public getAllCompanyInformation(data: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.GETALLCOMPANYINFO}`, data);
  }

  public createCompanyInfo(data: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.CREATECOMPANYINFO}`, data);
  }

  public updateCompanyInfo(data: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.UPDATECOMPANYINFO}`, data);
  }

  public deleteCompany(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_COMPANY, data);
  }

  public autoSearchCompanyInfo(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.AUTOSEARCHCOMPANYINFO}?searchText=${seachkey}`);
  }

  public autogenerateCompanyCode() {
    return this.httpClientService.get(CONFIG.INVENTORY.AUTOGENERATE_COMPANYCODE);
  }

  public uploadCompanyLogoImage(companyid: number, formData: FormData) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.UPLOAD_COMPANY_IMAGE}/${companyid} `, formData);
  }

  public getCompanyDetails() {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_COMPANY_DETAILS}`);
  }

  // user details end points.....


  public getUserById(id: any) {
    return this.httpClientService.get(`${CONFIG.USER.GETUSERBYUSER}?id=${id}`);
  }

  public updateUser(data: any) {
    return this.httpClientService.post(CONFIG.USER.UPDATEUSER, data);
  }

  public deleteUser(data: any) {
    return this.httpClientService.post(`${CONFIG.USER.DELETEUSER}`, data);
  }

  public getAllUser() {
    return this.httpClientService.get(`${CONFIG.USER.GET_ALLUSERS}`);
  }

  public autoSearchUserInfo(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.USER.AUTOSEARCHUSERINFO}?searchText=${seachkey}`);
  }

  public getUserRoleById(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.USER.GETUSERROLEBYID}?${queryParam}`);
  }

  public autoSearchRole(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.USER.AUTOSEARCHROLE}?searchText=${seachkey}`);
  }

  // assign role

  public createAssignRole(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.CREATEASSIGNROLE}`, data);
  }

  public getAllgetAssignRoleInfo(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.GET_ALLASSIGNROLES}`, data);
  }

  public updateAssignRole(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.UPDATEASSIGNROLE}`, data);
  }

  public inActiveuAssignRole(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.INACTIVEASSIGNROLE}`, data);
  }

  public getAssignRoleById(data: any) {
    let queryParam = `roleId=${data}`;
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GETASSIGNROLEBYID}?${queryParam}`);
  }

  public deleteAssignRole(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.DELETEASSIGNROLE}`, data);
  }

  public autosearchAssignRoles(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.AUTOSEARCHASSIGNROLES}?searchText=${seachkey}`);
  }

  public getCompanyWarehouse(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.GETCOMPANYWAREHOUSE}`, data);
  }

  public getProductType(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_PRODUCT_TYPE, data);
  }

  public getProductTypeById(id: any) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GET_PRODUCT_TYPE_BY_ID}?id=${id}`);
  }

  public createProductType(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.CREATE_PRODUCT_TYPE}`, data);
  }

  public updateProductType(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.UPDATE_PRODUCT_TYPE}`, data);
  }

  public deleteProductType(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.DELETE_PRODUCT_TYPE}`, data);
  }

  public searchProductType(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.SEARCH_PRODUCT_TYPE}?searchText=${seachkey}`);
  }
  public getAllColour(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.GETALLCOLOR}`, data);
  }
  public getAllColors() {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GET_ALL_COLORS}`);
  }

  public getAllProductGroups(data: any) {
    return this.httpClientService.post(`${CONFIG.ADMINISTRATION.GETALLPRODUCTGROUPS}`, data);
  }
  public getProductGrouptById(data: any) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GET_PRODUCTGROUPBYID}?id=${data}`);
  }

  public getColorByName(data: any) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GET_COLORBYNAME}?name=${data}`);
  }
  public getGroupByName(data: any) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GET_GROUPBYNAME}?name=${data}`);
  }
  public getSubCategoryByName(data: any) {
    return this.httpClientService.get(`${CONFIG.ADMINISTRATION.GET_SUBCATEGORYBYNAME}?name=${data}`);
  }

  public Savetransaction(data: any) {
    return this.httpClientService.post(`${CONFIG.POINTOFSALE.SAVE_TRANSACTION}`, data);
  }

  public getTransactions(data: any) {
    return this.httpClientService.get(`${CONFIG.POINTOFSALE.GET_TRANSACTIONS}`, data);
  }

  public getTransactionById(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.POINTOFSALE.GET_TRANSACTION_BY_ID}?${queryParam}`);
  }

  //CREATED BY NILESH FOR TDS TAXES
  public getSections(data: any) {
    return this.httpClientService.post(`${CONFIG.TDSSECTION.GET_SECTION}`, data);
  }

  public getPayableAccount(data: any) {
    return this.httpClientService.post(`${CONFIG.TDSSECTION.GET_PAYABLE_ACCOUNT}`, data);
  }

  public getReceivableAccount(data: any) {
    return this.httpClientService.post(`${CONFIG.TDSSECTION.GET_RECEIVABLE_ACCOUNT}`, data);
  }

  public getTaxes(data: any) {
    return this.httpClientService.post(`${CONFIG.TDSSECTION.GET_TAXES}`, data);
  }

  public deleteTaxes(data: any) {
    return this.httpClientService.post(`${CONFIG.TDSSECTION.DELETE_TAXES}`, data);
  }

  public createTaxes(data: any) {
    return this.httpClientService.post(`${CONFIG.TDSSECTION.CREATE_TAXES}`, data);
  }

  public updateTaxes(data: any) {
    return this.httpClientService.post(`${CONFIG.TDSSECTION.UPDATE_TAXES}`, data);
  }

  public getTaxesById(data: any) {
    return this.httpClientService.get(`${CONFIG.TDSSECTION.GET_TAXES_BY_ID}?id=${data}`);
  }

  public searchTaxes(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.TDSSECTION.SEARCH_TAXES}?searchText=${seachkey}`);
  }

  public checkTaxCode(data: any) {
    return this.httpClientService.get(`${CONFIG.TDSSECTION.CHECK_TAXCODE}?taxCode=${data}`);
  }

  //Created by Nilesh for Voucher Module
  public getAutogenerateNo() {
    return this.httpClientService.get(`${CONFIG.VOUCHER.AUTOGENERATE_VOUCHERCODE}`);
  }

  public checkVoucherNoExists(data: any) {
    return this.httpClientService.get(`${CONFIG.VOUCHER.CHECK_VOUCHER_NO}?voucherNo=${data}`);
  }

  public getVouchers(data: any) {
    return this.httpClientService.post(`${CONFIG.VOUCHER.GET_VOUCHERS}`, data);
  }

  public createVoucher(data: any) {
    return this.httpClientService.post(`${CONFIG.VOUCHER.CREATE_VOUCHER}`, data);
  }

  public updateVoucher(data: any) {
    return this.httpClientService.post(`${CONFIG.VOUCHER.UPDATE_VOUCHER}`, data);
  }

  public getVoucherById(data: any) {
    return this.httpClientService.get(`${CONFIG.VOUCHER.GET_VOUCHER_BY_ID}?id=${data}`);
  }

  public searchVouchers(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.VOUCHER.SEARCH_VOUCHER}?searchText=${seachkey}`);
  }

  public deleteVoucher(data: any) {
    return this.httpClientService.post(`${CONFIG.VOUCHER.DELETE_VOUCHER}`, data);
  }

  public createVoucherLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.VOUCHER.CREATE_VOUCHER_LINEITEM}`, data);
  }

  public getVoucherLineItemsById(id: number) {
    return this.httpClientService.get(`${CONFIG.VOUCHER.GET_VOUCHER_LINEITEMBYID}/${id}`);
  }

  public deleteVoucherLineItems(data: any) {
    return this.httpClientService.post(`${CONFIG.VOUCHER.DELETE_VOUCHER_LINEITEM}`, data);
  }

  public updateVoucherLineItems(data: any) {
    return this.httpClientService.post(`${CONFIG.VOUCHER.UPDATE_VOUCHER_LINEITEM}`, data);
  }

  public createVoucherAccountingTransaction(voucherId: number) {
    return this.httpClientService.post(
      `${CONFIG.VOUCHER.CREATE_ACCOUNTING_TRANSACTION}/${voucherId}`,
      {}
    );
  }

  public updateVoucherAccountingTransaction(voucherId: number) {
    return this.httpClientService.post(
      `${CONFIG.VOUCHER.UPDATE_ACCOUNTING_TRANSACTION}/${voucherId}`,
      {}
    );
  }
}
